import Theme from './Theme.vue'

export default Theme
